import * as React from "react";

import { ILocalizer, LocalizeStringCallback } from "./ILocalizer";

const LocalizerContext = React.createContext<LocalizeStringCallback>(x => x);

interface LocalizerProviderProps {
    localizer: ILocalizer;
    children: React.ReactNode;
}

export function LocalizerProvider(props: LocalizerProviderProps): JSX.Element {
    return <LocalizerContext.Provider value={props.localizer.translate}>{props.children}</LocalizerContext.Provider>;
}

export function useLocalizeString(): LocalizeStringCallback {
    return React.useContext(LocalizerContext);
}
